import { useCallback } from 'react';
import MuiTextField from '@material-ui/core/TextField';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiButton from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { ScaffolderField } from '@backstage/plugin-scaffolder-react/alpha';
import type {
  LinkItem,
  LinksListUiOptions,
  LinksListValue,
} from '../../schemas/linksListSchema';

export const LinksListField = (
  props: FieldExtensionComponentProps<LinksListValue, LinksListUiOptions>,
) => {
  const { formData, onChange, schema, rawErrors } = props;
  const links = formData ?? [];

  const updateLink = useCallback(
    (index: number, patch: Partial<LinkItem>) => {
      onChange(links.map((link, i) => (i === index ? { ...link, ...patch } : link)));
    },
    [links, onChange],
  );

  const removeLink = useCallback(
    (index: number) => {
      onChange(links.filter((_, i) => i !== index));
    },
    [links, onChange],
  );

  const addLink = useCallback(() => {
    onChange([...links, { title: '', url: '' }]);
  }, [links, onChange]);

  return (
    <ScaffolderField rawDescription={schema.description} rawErrors={rawErrors}>
      {links.map((link, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
          }}
        >
          <MuiTextField
            label="Title"
            margin="dense"
            value={link.title ?? ''}
            onChange={event => updateLink(index, { title: event.target.value })}
            style={{ flex: 2 }}
          />
          <MuiTextField
            label="URL"
            margin="dense"
            required
            value={link.url ?? ''}
            onChange={event => updateLink(index, { url: event.target.value })}
            style={{ flex: 3 }}
          />
          <MuiIconButton
            aria-label="Remove link"
            size="small"
            onClick={() => removeLink(index)}
            style={{ marginBottom: 4 }}
          >
            <CloseIcon fontSize="small" />
          </MuiIconButton>
        </div>
      ))}
      <MuiButton size="small" startIcon={<AddIcon />} onClick={addLink}>
        Add link
      </MuiButton>
    </ScaffolderField>
  );
};
